import sectors from '../config/sectors'

export default {
	namespaced: true,
	state: {
		list: []
	},
	getters: {

	},
	actions: {
		async getList({ commit }) {
			commit('set', { type: 'list', value: sectors.sectors })
		}
	},
	mutations: {
		set(state, { type, value }) {
			state[type] = value
		}
	}
}
